// @flow

import React from 'react'
import {toLower} from 'ramda'

type Props = {
  code: string,
}

const style = {
  display: 'inline-block',
}

const buildClass = (code: string) => {
  switch (code) {
    case 'EN':
      return 'en-flag'
    case 'WW':
      return 'ww-flag'
    default:
      return `flag flag-${toLower(code || '')}`
  }
}

export default ({code}: Props) =>
  <div
    style={style}
    className={buildClass(code)}
  />



// WEBPACK FOOTER //
// ./src/elements/flag.js